import gsap from "gsap";

class DeviceSpecs {
	constructor() {
		this.config = {
			allowMultipleExpanded: true
		};

		this.classes = {
			expanded: 'is-expanded'
		};

		this.selectors = {
			item: '.device-specs__acc-item',
			button: '.device-specs__acc-btn',
			content: '.device-specs__acc-content'
		};

		this.animation = {
			duration: 0.3
		};

		this.currentItem = null;
		this.pendingToggle = null;

		this.items = document.querySelectorAll(this.selectors.item);
	}

	setExpanded() {
		if (!this.pendingToggle) return;

		const { item, button, content, isExpanded } = this.pendingToggle;

		item.classList.toggle(this.classes.expanded, isExpanded);

		gsap.killTweensOf(content);

		button.setAttribute('aria-expanded', String(isExpanded));
		content.setAttribute('aria-hidden', String(!isExpanded));

		gsap.to(content, {
			height: isExpanded ? 'auto' : 0,
			opacity: isExpanded ? 1 : 0,
			duration: this.animation.duration
		});
	}

	collapseOtherItems() {
		this.items.forEach((item) => {
			if (item === this.currentItem || !item.classList.contains(this.classes.expanded)) return;

			const button = item.querySelector(this.selectors.button);
			const content = item.querySelector(this.selectors.content);

			if (!button || !content) return;

			this.pendingToggle = {
				item,
				button,
				content,
				isExpanded: false
			};

			this.setExpanded();
		});
	}

	init() {
		if (!this.items.length) return;

		this.items.forEach((item, index) => {
			const button = item.querySelector(this.selectors.button);
			const content = item.querySelector(this.selectors.content);

			if (!button || !content) return;

			const isExpanded = item.classList.contains(this.classes.expanded);

			if (!content.id) {
				content.id = `device-specs-content-${index + 1}`;
			}

			button.setAttribute('type', 'button');
			button.setAttribute('aria-controls', content.id);
			button.setAttribute('aria-expanded', String(isExpanded));

			content.setAttribute('aria-hidden', String(!isExpanded));

			if (isExpanded) {
				gsap.set(content, { height: 'auto', opacity: 1 });
			} else {
				gsap.set(content, { height: 0, opacity: 0 });
			}

			button.addEventListener('click', () => {
				const isExpandedNext = !item.classList.contains(this.classes.expanded);
				this.currentItem = item;

				if (!this.config.allowMultipleExpanded && isExpandedNext) {
					this.collapseOtherItems();
				}

				this.pendingToggle = {
					item,
					button,
					content,
					isExpanded: isExpandedNext
				};

				this.setExpanded();
			});
		});
	}
}

new DeviceSpecs().init();